import React, { useContext } from 'react';
import { IconButton } from '@chakra-ui/react';
import { FaGlobe } from 'react-icons/fa';
import LanguageContext from '../../Contexts/LangContext';

/**
 * A simplified LangSwitch component that gets its colors from CSS variables.
 * The `variant` prop has been removed as the component now adapts to the
 * global theme automatically.
 */
const LangSwitch = () => {
    const { toggleLang } = useContext(LanguageContext);

    // If the context is not yet available, don't render anything.
    if (!toggleLang) return null;

    // The component is now free of any color logic.
    return (
        <IconButton
            onClick={toggleLang}
            icon={<FaGlobe />}
            aria-label="Switch Language"
            isRound={true}
            variant="ghost"
            fontSize="20px"
            // UPDATED: All colors are now using CSS variables via the sx prop
            sx={{
                color: 'var(--ghost-icon-btn-color)',
                _hover: { 
                    bg: 'var(--ghost-icon-btn-hover-bg)',
                    color: 'var(--ghost-icon-btn-hover-color)' 
                }
            }}
        />
    );
};

export default LangSwitch;